import { Div, FontIcon, Text2, Text3 } from "components/Base";
import React, { useEffect } from "react";
import Loading from "ui-kit/Loading";
import Tooltip from "ui-kit/Tooltip";
import EmptyState from "EventLight/Common/EmptyState";

import { connect } from "react-redux";
import { actions, getters } from "../model";
import { getTasks } from "../selectors";
import { stripHtml } from "utils/General";

import { truncateDescription } from "Portal/NewPortal/Sections/Home/Cards/Tasks/View/Task";
import { TASK_TAB_IDS } from "../constants";

const decorate = connect(
  state => ({
    loadingTasks: getters.loadingTasks(state),
    tasks: getTasks(state),
    selectedTaskTab: getters.selectedTaskTab(state)
  }),
  {
    loadTasks: actions.loadTasks,
    setSelectedTaskTab: actions.setSelectedTaskTab
  }
);

const ParticipantTask = ({ task }) => {
  return (
    <Tooltip tooltip="Tasks are in view-only mode" placement="top">
      <Div
        mb={2}
        width={1}
        px={4}
        py={3}
        display="column.flex-start.flex-start"
        style={{
          borderRadius: "8px",
          border: "1px solid #E7E6EA",
          cursor: "pointer",
          ":hover": { opacity: 0.5 }
        }}
      >
        <Text3 color="#494949" bold display="row.flex-start.center">
          {task.name}
          {task.is_required ? (
            <>
              {" "}
              <Text3 style={{ color: "red" }}>*</Text3>
            </>
          ) : null}
        </Text3>
        {task.due_label ? (
          <Div
            display="row.flex-start.center"
            mt={1.75}
            style={{ gap: "6px", color: "#666666" }}
          >
            <i style={{ fontSize: "14px" }} className="material-icons-outlined">
              schedule
            </i>
            <Text2 color="#666666">{task.due_label}</Text2>
          </Div>
        ) : null}
        <Div
          width={1}
          my={2.5}
          bg="#E7E6EA"
          style={{
            height: "1px"
          }}
        />
        {task.description && task.description.length ? (
          <Text2 color="#666666">
            {truncateDescription(stripHtml(task.description), 250, true)}
          </Text2>
        ) : null}
        <Div mt={4} display="row.flex-start.center">
          <Div
            display="row.flex-start.center"
            px={2.5}
            py={1}
            style={{
              border: "1px solid #E7E6EA",
              background: "#FAFAFA",
              borderRadius: "4px",
              color: "#494949"
            }}
          >
            <FontIcon
              color={task.is_complete ? "#37B24D" : "#CE423A"}
              fs={3}
              from="material-icons"
            >
              {task.is_complete ? "check_circle" : "error"}
            </FontIcon>
            <Text2 ml={1}>
              {task.is_complete ? "Completed" : "Incomplete"}
            </Text2>
          </Div>

          {/*
          <Div
            ml={4}
            px={2.5}
            py={1}
            style={{
              border: `1px solid ${task.is_open ? "#B05D091F" : "#CB3B331F"}`,
              background: `${task.is_open ? "#FFF8EB" : "#FEF1F2"}`,
              borderRadius: "4px"
            }}
          >
            <Text2 style={{ color: `${task.is_open ? "#B05D09" : "#CB3B33"}` }}>
              {task.is_open ? "Open" : "Closed"}
            </Text2>
          </Div>
          */}
        </Div>
      </Div>
    </Tooltip>
  );
};

const Tasks = ({
  loadingTasks,
  loadTasks,
  tasks,
  setSelectedTaskTab,
  selectedTaskTab = TASK_TAB_IDS.ALL
}) => {
  useEffect(() => {
    setSelectedTaskTab(TASK_TAB_IDS.ALL);
    loadTasks();
  }, []);

  if (loadingTasks) {
    return <Loading />;
  }

  return (
    <Div px={4} py={3} width={1} display="column.flex-start.stretch">
      <Div
        display="row.flex-start.center"
        p={1}
        style={{ borderRadius: "6px", background: "#F2F2F2" }}
      >
        <Text2
          py={0.5}
          align="center"
          bold
          style={{
            flex: 1,
            borderRadius: "4px",
            cursor: "pointer",
            background: selectedTaskTab === "all" ? "white" : "none"
          }}
          onClick={() => setSelectedTaskTab(TASK_TAB_IDS.ALL)}
        >
          All
        </Text2>
        <Text2
          py={0.5}
          align="center"
          bold
          style={{
            flex: 1,
            borderRadius: "4px",
            cursor: "pointer",
            background: selectedTaskTab === "complete" ? "white" : "none"
          }}
          onClick={() => setSelectedTaskTab(TASK_TAB_IDS.COMPLETE)}
        >
          Complete
        </Text2>
        <Text2
          py={0.5}
          align="center"
          bold
          style={{
            flex: 1,
            borderRadius: "4px",
            cursor: "pointer",
            background: selectedTaskTab === "incomplete" ? "white" : "none"
          }}
          onClick={() => setSelectedTaskTab(TASK_TAB_IDS.INCOMPLETE)}
        >
          Incomplete
        </Text2>
        <Text2
          py={0.5}
          align="center"
          bold
          style={{
            flex: 1,
            borderRadius: "4px",
            cursor: "pointer",
            background: selectedTaskTab === "due" ? "white" : "none"
          }}
          onClick={() => setSelectedTaskTab(TASK_TAB_IDS.DUE)}
        >
          Due
        </Text2>
      </Div>
      <Div mt={2} display="column.flex-start.stretch">
        {!tasks.length ? (
          <EmptyState
            icon="task"
            title={
              selectedTaskTab !== TASK_TAB_IDS.ALL
                ? "No tasks match this filter"
                : "No tasks assigned"
            }
          />
        ) : (
          tasks.map(task => <ParticipantTask key={task.id} task={task} />)
        )}
      </Div>
    </Div>
  );
};

export default decorate(Tasks);
